import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/CanNotAccess",
    name: "CanNotAccess",
    component: () => import("@/views/CanNotAccess.vue"),
    meta: { title: "PEAK Board" },
  },
  {
    path: "/CanNotAccessMerchant",
    name: "canNotAccessMerchant",
    component: () => import("@/views/CanNotAccessMerchant.vue"),
    meta: { title: "PEAK Board" },
  },
  {
    path: "/SessionExpire",
    name: "sessionExpire",
    component: () => import("@/views/SessionExpire.vue"),
    meta: { title: "PEAK Board" },
  },
  { path: "*", redirect: "/404" },
  {
    path: "/404",
    name: "pageNotFound",
    component: () => import("@/views/PageNotFound.vue"),
    meta: { title: "PEAK Board" },
  },
  {
    path: "/",
    name: "login",
    component: () => import("@/views/login/LoginPage.vue"),
    meta: { title: "PEAK Board" },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("@/views/login/LogOut.vue"),
    meta: { title: "PEAK Board" },
  },
  {
    path: "/selectList",
    name: "selectList",
    component: () => import("@/views/selectCompany/SelectList.vue"),
    meta: { title: "PEAK Board" },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/Home.vue"),
    meta: { title: "Menu_Dashboard", breadcrumb: [{ name: "Menu_Dashboard" }] },
  },
  {
    path: "/custom",
    name: "custom",
    component: () => import("@/views/custom/Custom.vue"),
    meta: { title: "Menu_Custom", breadcrumb: [{ name: "Menu_Custom" }] },
  },
  {
    path: "/customDashboardDetail",
    name: "customDashboardDetail",
    component: () => import("@/views/custom/detail/CustomDashboardDetail.vue"),
    meta: {
      title: "Menu_Custom",
      breadcrumb: [{ name: "Menu_Custom", linkName: "custom" }],
    },
  },
  {
    path: "/exampleDashboard",
    name: "exampleDashboard",
    component: () => import("@/views/custom/detail/CustomDashboardDetailMockup.vue"),
    meta: {
      title: "Menu_Custom",
      breadcrumb: [{ name: "Menu_Custom", linkName: "custom" }, { name: "Example_Dashboard" }],
    },
  },
  {
    path: "/executiveSummary",
    name: "executiveSummary",
    component: () => import("@/views/executiveSummary/ExecutiveSummary.vue"),
    meta: { title: "Menu_Analyst", breadcrumb: [{ name: "Menu_Analyst" }] },
  },
  {
    path: "/executiveSummaryTable",
    name: "executiveSummaryTable",
    component: () => import("@/views/executiveSummary/ExecutiveSummaryTable.vue"),
    meta: {
      title: "Menu_Analyst",
      breadcrumb: [{ name: "Menu_Analyst", linkName: "executiveSummary" }, { name: "Executive_Summary" }],
    },
  },
  {
    path: "/executiveSummaryCreate",
    name: "executiveSummaryCreate",
    component: () => import("@/views/executiveSummary/ExecutiveSummaryCreate.vue"),
    meta: {
      title: "Menu_Analyst",
      breadcrumb: [{ name: "Menu_Analyst", linkName: "executiveSummary" }, { name: "Executive_Summary_Create" }],
    },
  },
  {
    path: "/executiveSummaryEdit",
    name: "executiveSummaryEdit",
    component: () => import("@/views/executiveSummary/ExecutiveSummaryEdit.vue"),
    meta: {
      title: "Menu_Analyst",
      breadcrumb: [{ name: "Menu_Analyst", linkName: "executiveSummary" }, { name: "Executive_Summary_Edit" }],
    },
  },
  {
    path: "/executiveSummaryDetail",
    name: "executiveSummaryDetail",
    component: () => import("@/views/executiveSummary/ExecutiveSummaryDetail.vue"),
    meta: {
      title: "Menu_Analyst",
      breadcrumb: [{ name: "Menu_Analyst", linkName: "executiveSummary" }, { name: "Executive_Summary" }],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (from && to && from.name !== to.name) {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
